// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-avatar[data-v-7830d3d4]{vertical-align:middle;width:100%}.default-avatar[data-v-7830d3d4] .cls-1{fill:var(--letter-color)}.default-avatar[data-v-7830d3d4] .cls-2{fill:var(--bg-color)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
